import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo.png" alt="Prime Crown Assets" className="footer-logo-img" />
              <h3>Prime Crown <span>Assets</span></h3>
            </Link>
            <p className="tagline">Your Trusted Real Estate Partner in Coimbatore</p>
            <p>Prime Crown Assets offers comprehensive real estate and construction services in Coimbatore, Tamil Nadu including DTCP approved layouts, building construction, land sales, and property documentation.</p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook"><FaFacebook /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter"><FaTwitter /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn"><FaLinkedin /></a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <div className="footer-links">
              <Link to="/about">About Us</Link>
              <Link to="/services">Services</Link>
              <Link to="/gallery">Gallery</Link>
              <Link to="/testimonials">Testimonials</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <div className="footer-links">
              <Link to="/services/construction">Construction</Link>
              <Link to="/services/land-sale">Land Sale</Link>
              <Link to="/services/documentation">Documentation</Link>
              <Link to="/services/interior">Interior Design</Link>
              <Link to="/services/renovation">Renovation</Link>
            </div>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="footer-contact-item">
              <FaMapMarkerAlt className="icon" />
              <span>Thulasiram Plaza, SamiChettipalayam Road,<br />Vannan Kovil Pirivu,<br />Coimbatore-641047</span>
            </div>
            <div className="footer-contact-item">
              <FaPhone className="icon" />
              <span>+91 97911 77445</span>
            </div>
            <div className="footer-contact-item">
              <FaEnvelope className="icon" />
              <span>primecrownassets@gmail.com</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Prime Crown Assets. All rights reserved. | Real Estate & Construction Services in Coimbatore, Tamil Nadu</p>
          <p className="developer-credit">
            Developed by <a href="https://varnyxtechnologies.com/" target="_blank" rel="noopener noreferrer">Varnyx Technologies</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
